module.exports = __webpack_public_path__ + "img/windtre_logotype.122463f6.svg";